export const weekDays = new Map([
  [0, 'Понедельник'],
  [1, 'Вторник'],
  [2, 'Среда'],
  [3, 'Четверг'],
  [4, 'Пятница'],
  [5, 'Суббота'],
  [6, 'Воскресенье'],
]);

export const evenOddDays = new Map([
  [7, 'Четные'],
  [8, 'Нечетные'],
]);
